// List of chars from https://stackoverflow.com/a/1547940 plus % (for %-encoding).
// Note: This excludes non-ASCII chars, which are arguably legal, especially if they
// appear in the actual domain name. However, Google Classroom appears to disallow them,
// so we do too.
const URL_VALID_REGEX = /^[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]*$/

/** Ensure the final URL actually starts with a protocol after applying withProtocol. */
const PROTOCOL_REGEX = /^[A-Za-z][A-Za-z0-9+\-.]*:\/\//

/**
 * Add protocol if needed. This prevents the link from opening relative to the page
 * and also avoids https://github.com/ueberdosis/tiptap/issues/5824
 */
export const withProtocol = (url: string) => (url.includes("://") ? url : "https://" + url)

export const isValidUrl = (url: string) =>
  URL_VALID_REGEX.test(url) && PROTOCOL_REGEX.test(withProtocol(url))
